<template>
  <v-app class="app">
    <AppBar />
    <v-main>
      <v-container fluid>
        <LayoutMonitorMain />
      </v-container>
    </v-main>
    <Footer />
  </v-app>
</template>

<script>
import Footer from '@/componentes/Footer'

import LayoutMonitorMain from './LayoutMonitorMain'
import AppBar from '../_components/AppBar'

export default {
  name: 'MonitorCallCenterHome',
  components: { AppBar, LayoutMonitorMain, Footer },
  data: () => ({
    version: process.env.VUE_APP_VERSION,
  }),
}
</script>

<style scoped>
.app {
  background-color: var(--v-background-base);
}
</style>
